// @ts-nocheck
import React from 'react';
import { Monitor, Moon, Sun, Check } from 'lucide-react';
import { useTheme } from '../../../theme/ThemeProvider';
import { Section } from './primitives';

/* Appearance — per-user theme + accent. Changes apply and persist instantly
   (useTheme writes them per user+tenant), so there's no save bar. Accent is a
   fixed token-driven preset set, never a freeform hex. */

const MODE_OPTIONS = [
  { key: 'light', label: 'Light', Icon: Sun },
  { key: 'dark', label: 'Dark', Icon: Moon },
  { key: 'system', label: 'System', Icon: Monitor },
];

export default function AppearanceTab() {
  const { mode, resolvedMode, accent, setMode, setAccent, presets } = useTheme();

  return (
    <div className="sv2-body">
      <div className="sv2-col">
        <Section id="theme" title="Theme" sub="Choose light, dark, or follow your device.">
          <div className="appearance-modes" role="radiogroup" aria-label="Theme">
            {MODE_OPTIONS.map(({ key, label, Icon }) => (
              <button
                key={key}
                type="button"
                role="radio"
                aria-checked={mode === key}
                className={`appearance-mode ${mode === key ? 'is-active' : ''}`}
                onClick={() => setMode(key)}
              >
                <Icon size={18} />
                <span>{label}</span>
                {key === 'system' ? (
                  <span className="appearance-mode-hint">
                    {resolvedMode === 'dark' ? 'Dark now' : 'Light now'}
                  </span>
                ) : null}
              </button>
            ))}
          </div>
        </Section>

        <Section id="accent" title="Accent color" sub="Used for buttons, links, and highlights.">
          <div className="appearance-accents" role="radiogroup" aria-label="Accent color">
            {presets.map((preset) => (
              <button
                key={preset.key}
                type="button"
                role="radio"
                aria-checked={accent === preset.key}
                className={`appearance-accent ${accent === preset.key ? 'is-active' : ''}`}
                onClick={() => setAccent(preset.key)}
                title={preset.label}
              >
                <span
                  className="appearance-swatch"
                  style={{ background: preset.primary }}
                  aria-hidden="true"
                >
                  {accent === preset.key ? <Check size={14} /> : null}
                </span>
                <span className="appearance-accent-label">{preset.label}</span>
              </button>
            ))}
          </div>
        </Section>
      </div>
    </div>
  );
}
